//React imports
import React, { useState, useEffect } from 'react';
//---

//CSS imports
import './Docs.css'
//---

//PrimeReact imports

//---

//Vendors imports
import axios from 'axios';
//---

//Components imports
import { useNotification } from '../../components/NotificationProvider';
//---

//Data requests imports
import {
    readAecProject
} from '../../data/AecProjectData';
import {
    defaultAecProject
} from '../../data/DefaultStates';
//---

const AEC_API_URL = process.env.REACT_APP_AEC_API_URL;

const Docs = ({ projectName }) => {
    const cancelTokenSource = axios.CancelToken.source();

    const { showNotification } = useNotification();

    const [aecProject, setAecProject] = useState(defaultAecProject);

    useEffect(() => {
        readAecProject(cancelTokenSource, projectName).then(
            data => {
                if (data.aecProject) {
                    setAecProject(data.aecProject);
                }
            },
            errorMessage => showNotification('error', 'Error', errorMessage, 6000)
        );
        return () => {
            cancelTokenSource.cancel();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div>
            {
                aecProject.docsURL !== '' ?
                    <iframe
                        id="dbt-docs"
                        title="dbt-docs"
                        className='dbt-docs-iframe'
                        width="100%"
                        height="100%"
                        src={AEC_API_URL + aecProject.docsURL}>
                    </iframe> :
                    null
            }
        </div>
    );
};

export default Docs;
